export default __webpack_public_path__ + "media/ce695c2d6c238307c27f696ed90fffd7.png";